<template>
    <div class="form-item">
        <label class="label-caption">Situação</label>
        <select :value="opcaoSelecionada" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        opcaoSelecionada: {type: Number, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 1, descricao: 'EM DIGITAÇÃO' },
                { id: 2, descricao: 'AGUARDANDO ESTABELECIMENTO' },
                { id: 3, descricao: 'AGUARDANDO RT' },
                { id: 4, descricao: 'AGUARDANDO HOMOLOGAÇÃO' },
                { id: 5, descricao: 'HOMOLOGADA' },
                { id: 9, descricao: 'CANCELADA' }
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: 0, descricao: 'TODAS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:opcaoSelecionada', Number(event.target.value));
        }
    }
};
</script>